import {
  PRODUCT_FILTER_REQUESTING,
  LIST_PRODUCT_FILTER_WINE_TYPES_SUCCESS,
  LIST_PRODUCT_FILTER_WINE_VARIETALS_SUCCESS,
  LIST_PRODUCT_FILTER_WINE_COUNTRY_CODES_SUCCESS,
  LIST_PRODUCT_FILTER_WINE_REGIONS_SUCCESS,
  LIST_PRODUCT_FILTER_WINE_APPELLATIONS_SUCCESS,
  LIST_PRODUCT_FILTER_VENDORS_SUCCESS,
  RESET_PRODUCT_FILTER_ISFETCHING,
  LIST_PRODUCT_FILTER_WINE_VINTAGES_SUCCESS
} from './constants';

const INITIAL_STATE = {
  wineTypes: [],
  wineVarietals: [],
  wineCountryCodes: [],
  wineRegions: [],
  wineAppellations: [],
  wineVintages: [],
  vendors: [],
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_PRODUCT_FILTER_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case PRODUCT_FILTER_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case LIST_PRODUCT_FILTER_WINE_TYPES_SUCCESS: {
      return {
        ...state,
        wineTypes: action.payload,
        isFetching: false
      };
    }
    case LIST_PRODUCT_FILTER_WINE_VARIETALS_SUCCESS: {
      return {
        ...state,
        wineVarietals: action.payload,
        isFetching: false
      };
    }
    case LIST_PRODUCT_FILTER_WINE_COUNTRY_CODES_SUCCESS: {
      return {
        ...state,
        wineCountryCodes: action.payload,
        isFetching: false
      };
    }
    case LIST_PRODUCT_FILTER_WINE_REGIONS_SUCCESS: {
      return {
        ...state,
        wineRegions: action.payload,
        isFetching: false
      };
    }
    case LIST_PRODUCT_FILTER_WINE_APPELLATIONS_SUCCESS: {
      return {
        ...state,
        wineAppellations: action.payload,
        isFetching: false
      };
    }
    case LIST_PRODUCT_FILTER_VENDORS_SUCCESS: {
      return {
        ...state,
        vendors: action.payload,
        isFetching: false
      };
    }
    case LIST_PRODUCT_FILTER_WINE_VINTAGES_SUCCESS: {
      return {
        ...state,
        wineVintages: action.payload,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
